import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import _throttle from 'lodash/throttle';
import SmoothCollapse from 'react-smooth-collapse';
import Slider from 'rc-slider';
import ChevronDownIcon from 'calcite-ui-icons-react/ChevronDownIcon';

import { RootState } from '../../../../reducers/app';
import { IHandleProps } from '../../../../types/timeline';
import { leftpanel } from '../../../../config/leftpanel.config';

import MapController from '../../../../controllers/MapController';

import './my-layer.scss';
import '../range-with-inputs.scss';
import 'rc-slider/assets/index.css';
import LayerTooltip from './layer-tooltip';
import InfoSvg from '../../../../assets/info-icon';

const { Range, Handle } = Slider;

const handle = (props: IHandleProps) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Handle key={index} value={value} {...restProps}>
      <div className='inner'>
        <div className={`range-tooltip${dragging ? ' active' : ''}`}>
          <span className='range-tooltip-inner'>{2000 + value}</span>
        </div>
      </div>
    </Handle>
  );
};

const MyLayer = ({ layer }: { layer: any }) => {
  // LOCAL STATE
  const [hansenVisibleYears, setHansenVisibleYears] = useState<Array<number>>(
    layer.renderingRule.functionArguments.IncludedRanges
  );
  const [sectionOpen, setSectionOpen] = useState<boolean>(true);

  // REDUX
  const visibleLayers = useSelector((state: RootState) => state.mapview.visibleLayers);

  // REFS
  const legendContainerRef = React.createRef<any>();

  useEffect(() => {
    MapController.fetchLegendInfo(legendContainerRef.current, layer.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    MapController.updateHansenVisibleYears(hansenVisibleYears);
  }, [hansenVisibleYears]);

  const throttledSetHansenVisibleYears = _throttle(setHansenVisibleYears, 250, { trailing: true });

  const endMark = leftpanel.hansenEndYear - 2000;

  const marks = { 1: 2001, [endMark]: leftpanel.hansenEndYear };

  return (
    <div className='layer-container' key={layer.id}>
      <div className='layer'>
        <div className='layer-title__wrapper'>
          <input
            type='checkbox'
            id={layer.id}
            name={layer.id}
            checked={visibleLayers.includes(layer.id)}
            onChange={() => MapController.updateLayerVisibility(layer.id, !visibleLayers.includes(layer.id))}
          />
          <div className='layer-title'>{layer.title}</div>
        </div>
        <div className='tools'>
          {layer.description && layer.description.length > 0 && (
            <LayerTooltip tip={layer.description}>
              <InfoSvg />
            </LayerTooltip>
          )}
          <ChevronDownIcon
            className={sectionOpen ? 'open' : ''}
            size={24}
            onClick={() => setSectionOpen(!sectionOpen)}
          />
        </div>
      </div>
      <SmoothCollapse className='hansen-container' eagerRender={true} expanded={sectionOpen} allowOverflowWhenOpen>
        <div className='hansen-legend'>
          <svg width='20' height='20'>
            <rect width='20' height='20' fill='rgba(255, 20, 147, 1)' />
          </svg>
          <div className='legend__name'>Tree Cover Loss</div>
        </div>
        <div className='range-with-inputs-container less-bottom'>
          <div className='range-input'>
            <Range
              className={'range-slider'}
              value={hansenVisibleYears}
              min={1}
              max={endMark}
              step={1}
              marks={marks}
              handle={handle}
              handleStyle={[{ borderColor: '#295C4D' }, { borderColor: '#295C4D' }]}
              onChange={(values: Array<number>) => throttledSetHansenVisibleYears(values)}
            />
          </div>
          <div className='range-title'>Select Time Range</div>
        </div>
      </SmoothCollapse>
    </div>
  );
};

export default MyLayer;
